import { render, staticRenderFns } from "./ItineraryCar.vue?vue&type=template&id=15841f56&scoped=true&"
import script from "./ItineraryCar.vue?vue&type=script&lang=js&"
export * from "./ItineraryCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15841f56",
  null
  
)

export default component.exports